/* tslint:disable: no-use-before-declare */
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

export enum typeMask {
  dot_separator,
}

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormInputTextComponent),
  multi: true,
};

@Component({
  selector: 'app-form-input-text',
  templateUrl: './form-input-text.component.html',
  styleUrls: ['./form-input-text.component.sass'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class FormInputTextComponent implements OnInit, ControlValueAccessor {
  errors: any;
  typeMaskEnum = typeMask;

  @Input() messageError: string;
  @Input() typeNumber: string;
  @Input() maxlength = 100;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() typeMask: typeMask;
  @Input() prefix: string;
  @Input() suffix: string;
  @Input() disabled = false;
  @Input() type = 'text';
  @ViewChild('input') input: ElementRef;
  @Input()
  public cellphoneMask: Subject<string> = new Subject();
  @Output() lostFocus: EventEmitter<any> = new EventEmitter();
  @Input() hasError = true;

  @Input() visibilityButton = false;
  @Input() autocomplete;

  @Input() innerValue: any = '';
  textIsVisible: boolean;

  constructor() {}

  ngOnInit() {
    if (this.type === 'password') {
      this.textIsVisible = false;
    }
  }

  onChange(e: Event, value: string) {
    this.innerValue = value;
    this.propagateChange(this.innerValue);
    this.lostFocus.emit();
  }

  @Input()
  @Output()
  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
    }
  }

  propagateChange = (_: any) => {};

  writeValue(value: any) {
    this.innerValue = value;
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {}

  isNumberKey(event) {
    const charCode = event.which;
    if (
      this.input.nativeElement.value.length >= this.maxlength &&
      charCode > 31
    ) {
      return false;
    }
    if (!this.typeNumber) {
      return true;
    }
    if (!isNaN(Number(event.key))) {
      return true;
    }
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      (charCode < 37 || charCode > 40)
    ) {
      return false;
    }

    return true;
  }
  onPaste(event) {
    const pastedText = event.clipboardData.getData('text');
    if (!isNaN(parseFloat(pastedText)) && isFinite(pastedText)) {
      return;
    }

    event.preventDefault();
  }

  changeVisibility() {
    if (this.textIsVisible) {
      this.type = 'password';
    } else {
      this.type = 'text';
    }
    this.textIsVisible = !this.textIsVisible;
  }
}
